var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTooltipicon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Tooltip_icon",
    "data-name": "Tooltip icon",
    d: "M12,0A12,12,0,1,0,24,12,12.035,12.035,0,0,0,12,0Zm-.12,19.92a1.68,1.68,0,1,1,1.68-1.68A1.64,1.64,0,0,1,11.88,19.92Zm3.24-9.36L13.8,12a1.466,1.466,0,0,0-.48,1.08,1.459,1.459,0,0,1-1.44,1.44,1.386,1.386,0,0,1-1.44-1.44,2.678,2.678,0,0,1,.96-2.16L12.48,9.6a2.724,2.724,0,0,0,.84-1.68A1.259,1.259,0,0,0,12,6.6a1.412,1.412,0,0,0-1.44,1.08,1.567,1.567,0,0,1-1.44.84A1.259,1.259,0,0,1,7.8,7.2a1.3,1.3,0,0,1,.12-.6A4,4,0,0,1,12,4.08a3.888,3.888,0,0,1,4.2,3.84A3.937,3.937,0,0,1,15.12,10.56Z",
    fill: "#2e6d96"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTooltipicon);
export default __webpack_public_path__ + "static/media/Tooltip icon.5ceca36e6daa84cfd8882dee1d97fe1c.svg";
export { ForwardRef as ReactComponent };